export enum AddressStyle {
    formal = 'formal',
    informal = 'informal'
}

export const addressStyles = Object.values(AddressStyle) as string[]
